<template>
    <el-form-item class="radio-container" :label="label">
        <el-radio-group class="radio-group" v-model="selectValue" :disabled="disable" fill="#009798" text-color="#ffffff" v-for="value in radios" :key="value" @change="radioChange">
            <el-radio-button class="radio-button" :label="value">{{value}}</el-radio-button>
        </el-radio-group>
    </el-form-item>
</template>

<script>
export default {
    props:{
        radios:{
            default: function() {
                return [];
            },
            type: Array,
            required: true
        },
        label:'',
        must:{
            type: Number,
            default: 0
        },
        colon:{
            type: Number,
            default: 0
        },
        disable:false,
        value:''
    },
    data () {
        return {
            selectValue:''
        }
    },
    mounted(){
        this.selectValue = this.value
    },
    methods:{
        radioChange(){
            this.$emit("input",this.selectValue)
        }
    }
}
</script>

<style scoped>

.radio-container{
    width: auto;
    height: 36px;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.radio-container>span{
    font-size: 17px !important;
    color: #333333;
}
.radio-container>span>b{
    width: 100px;
    font-size: 17px;
    color: #FF2B2B;
    text-align: right;
}
.radio-group{
    position: relative;
    right: 125px;
}
.radio-button{
    margin: 0 8px;
}

/* 未选中：边框颜色和圆角 */
.radio-button >>> .el-radio-button__inner {
    border-color: #e3e6e1;
    border-radius: 6px;
    font-size: 17px !important;
}

/* 选中态：fill 已控制背景+文字，这里加强边框和阴影 */
.radio-button >>> .el-radio-button.is-active .el-radio-button__inner {
    border-color: #009798;
    box-shadow: 0 2px 8px rgba(0, 151, 152, 0.25);
}
</style>
